import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { workflowService, WorkflowAuditLog } from '@/services/features/WorkflowService';
import { useErrorHandler } from '@/hooks/useErrorHandler';

export const useWorkflowAuditLog = (workflowId: number | null) => {
  const { hasuraToken } = useAuth();
  const { handleError } = useErrorHandler();
  const [auditLogs, setAuditLogs] = useState<WorkflowAuditLog[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!hasuraToken || !workflowId) {
        setAuditLogs([]);
        return;
      }

      setLoading(true);
      try {
        const result = await workflowService.getWorkflowAuditLog(hasuraToken, workflowId);
        
        if (result.success && result.data) {
          setAuditLogs(result.data.pep_workflow_audit_log || []);
        } else {
          handleError(result.errors?.[0] || 'Failed to fetch audit logs');
          setAuditLogs([]);
        }
      } catch (err) {
        handleError(err, 'Error fetching audit logs');
        setAuditLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditLogs();
  }, [hasuraToken, workflowId, handleError]);

  return { auditLogs, loading };
};
